/* Shared case-studio font, effect and preset definitions (snapshot). */
window.STRAYZY_WALL_CATALOG = {
  "fonts": [
    {
      "label": "Arial",
      "value": "Arial, Helvetica, sans-serif"
    },
    {
      "label": "Archivo Black",
      "value": "'Archivo Black', Arial, sans-serif"
    },
    {
      "label": "Anton",
      "value": "'Anton', Impact, sans-serif"
    },
    {
      "label": "Inter",
      "value": "'Inter', Arial, sans-serif"
    },
    {
      "label": "DM Sans",
      "value": "'DM Sans', Arial, sans-serif"
    },
    {
      "label": "Raleway",
      "value": "'Raleway', Arial, sans-serif"
    },
    {
      "label": "Helvetica",
      "value": "Helvetica, Arial, sans-serif"
    },
    {
      "label": "Arial Black",
      "value": "'Arial Black', Gadget, sans-serif"
    },
    {
      "label": "Arial Narrow",
      "value": "'Arial Narrow', Arial, sans-serif"
    },
    {
      "label": "Verdana",
      "value": "Verdana, Geneva, sans-serif"
    },
    {
      "label": "Trebuchet",
      "value": "'Trebuchet MS', Arial, sans-serif"
    },
    {
      "label": "Tahoma",
      "value": "Tahoma, Geneva, sans-serif"
    },
    {
      "label": "Calibri",
      "value": "Calibri, Candara, Segoe, sans-serif"
    },
    {
      "label": "Cambria",
      "value": "Cambria, Georgia, serif"
    },
    {
      "label": "Candara",
      "value": "Candara, Calibri, sans-serif"
    },
    {
      "label": "Century Gothic",
      "value": "'Century Gothic', CenturyGothic, AppleGothic, sans-serif"
    },
    {
      "label": "Consolas",
      "value": "Consolas, Monaco, monospace"
    },
    {
      "label": "Copperplate",
      "value": "Copperplate, 'Copperplate Gothic Light', fantasy"
    },
    {
      "label": "Didot",
      "value": "Didot, 'Bodoni 72', serif"
    },
    {
      "label": "Franklin Gothic",
      "value": "'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif"
    },
    {
      "label": "Gill Sans",
      "value": "'Gill Sans', 'Gill Sans MT', Calibri, sans-serif"
    },
    {
      "label": "Georgia",
      "value": "Georgia, serif"
    },
    {
      "label": "Times",
      "value": "'Times New Roman', Times, serif"
    },
    {
      "label": "Garamond",
      "value": "Garamond, Georgia, serif"
    },
    {
      "label": "Hoefler Text",
      "value": "'Hoefler Text', Garamond, serif"
    },
    {
      "label": "Courier",
      "value": "'Courier New', Courier, monospace"
    },
    {
      "label": "Impact",
      "value": "Impact, Haettenschweiler, sans-serif"
    },
    {
      "label": "Comic Sans",
      "value": "'Comic Sans MS', cursive"
    },
    {
      "label": "Brush Script",
      "value": "'Brush Script MT', cursive"
    },
    {
      "label": "Lucida Handwriting",
      "value": "'Lucida Handwriting', cursive"
    },
    {
      "label": "Lucida Sans",
      "value": "'Lucida Sans Unicode', 'Lucida Grande', sans-serif"
    },
    {
      "label": "Monaco",
      "value": "Monaco, Consolas, monospace"
    },
    {
      "label": "Papyrus",
      "value": "Papyrus, fantasy"
    },
    {
      "label": "Rockwell",
      "value": "Rockwell, 'Courier Bold', serif"
    },
    {
      "label": "Segoe UI",
      "value": "'Segoe UI', Arial, sans-serif"
    },
    {
      "label": "Segoe Script",
      "value": "'Segoe Script', 'Brush Script MT', cursive"
    },
    {
      "label": "Segoe Print",
      "value": "'Segoe Print', 'Comic Sans MS', cursive"
    },
    {
      "label": "Palatino",
      "value": "'Palatino Linotype', Palatino, serif"
    },
    {
      "label": "Optima",
      "value": "Optima, Candara, sans-serif"
    },
    {
      "label": "Futura",
      "value": "Futura, 'Trebuchet MS', Arial, sans-serif"
    },
    {
      "label": "Baskerville",
      "value": "Baskerville, 'Times New Roman', serif"
    },
    {
      "label": "Poppins",
      "value": "'Poppins', Arial, sans-serif"
    },
    {
      "label": "Montserrat",
      "value": "'Montserrat', Arial, sans-serif"
    },
    {
      "label": "Bebas Neue",
      "value": "'Bebas Neue', Impact, sans-serif"
    },
    {
      "label": "Bungee",
      "value": "'Bungee', Impact, sans-serif"
    },
    {
      "label": "Lilita One",
      "value": "'Lilita One', Arial, sans-serif"
    },
    {
      "label": "Luckiest Guy",
      "value": "'Luckiest Guy', Arial, sans-serif"
    },
    {
      "label": "Fredoka",
      "value": "'Fredoka', Arial, sans-serif"
    },
    {
      "label": "Chewy",
      "value": "'Chewy', 'Comic Sans MS', cursive"
    },
    {
      "label": "Rubik Bubbles",
      "value": "'Rubik Bubbles', 'Arial Black', sans-serif"
    },
    {
      "label": "Righteous",
      "value": "'Righteous', Arial, sans-serif"
    },
    {
      "label": "Audiowide",
      "value": "'Audiowide', Arial, sans-serif"
    },
    {
      "label": "Orbitron",
      "value": "'Orbitron', Arial, sans-serif"
    },
    {
      "label": "Monoton",
      "value": "'Monoton', Impact, sans-serif"
    },
    {
      "label": "Press Start 2P",
      "value": "'Press Start 2P', monospace"
    },
    {
      "label": "Permanent Marker",
      "value": "'Permanent Marker', 'Comic Sans MS', cursive"
    },
    {
      "label": "Pacifico",
      "value": "'Pacifico', cursive"
    },
    {
      "label": "Lobster",
      "value": "'Lobster', cursive"
    },
    {
      "label": "Satisfy",
      "value": "'Satisfy', cursive"
    },
    {
      "label": "Great Vibes",
      "value": "'Great Vibes', cursive"
    },
    {
      "label": "Caveat",
      "value": "'Caveat', cursive"
    },
    {
      "label": "Playfair Display",
      "value": "'Playfair Display', Georgia, serif"
    },
    {
      "label": "DM Serif Display",
      "value": "'DM Serif Display', Georgia, serif"
    },
    {
      "label": "Abril Fatface",
      "value": "'Abril Fatface', Georgia, serif"
    },
    {
      "label": "Cinzel",
      "value": "'Cinzel', Georgia, serif"
    },
    {
      "label": "Oswald",
      "value": "'Oswald', Arial, sans-serif"
    },
    {
      "label": "Comfortaa",
      "value": "'Comfortaa', Arial, sans-serif"
    },
    {
      "label": "Quicksand",
      "value": "'Quicksand', Arial, sans-serif"
    },
    {
      "label": "Rubik Glitch",
      "value": "'Rubik Glitch', sans-serif"
    },
    {
      "label": "Rubik Wet Paint",
      "value": "'Rubik Wet Paint', sans-serif"
    },
    {
      "label": "Rubik Moonrocks",
      "value": "'Rubik Moonrocks', sans-serif"
    },
    {
      "label": "Rubik Puddles",
      "value": "'Rubik Puddles', sans-serif"
    },
    {
      "label": "Rubik Vinyl",
      "value": "'Rubik Vinyl', sans-serif"
    },
    {
      "label": "Rubik Mono One",
      "value": "'Rubik Mono One', monospace"
    },
    {
      "label": "VT323",
      "value": "'VT323', monospace"
    },
    {
      "label": "Silkscreen",
      "value": "'Silkscreen', monospace"
    },
    {
      "label": "Black Ops One",
      "value": "'Black Ops One', sans-serif"
    },
    {
      "label": "Michroma",
      "value": "'Michroma', sans-serif"
    },
    {
      "label": "Chakra Petch",
      "value": "'Chakra Petch', sans-serif"
    },
    {
      "label": "Rajdhani",
      "value": "'Rajdhani', sans-serif"
    },
    {
      "label": "Space Grotesk",
      "value": "'Space Grotesk', sans-serif"
    },
    {
      "label": "Space Mono",
      "value": "'Space Mono', monospace"
    },
    {
      "label": "Dela Gothic One",
      "value": "'Dela Gothic One', sans-serif"
    },
    {
      "label": "Racing Sans One",
      "value": "'Racing Sans One', sans-serif"
    },
    {
      "label": "Oleo Script",
      "value": "'Oleo Script', cursive"
    },
    {
      "label": "Sacramento",
      "value": "'Sacramento', cursive"
    },
    {
      "label": "Dancing Script",
      "value": "'Dancing Script', cursive"
    },
    {
      "label": "Creepster",
      "value": "'Creepster', sans-serif"
    },
    {
      "label": "Titan One",
      "value": "'Titan One', sans-serif"
    },
    {
      "label": "Bangers",
      "value": "'Bangers', sans-serif"
    },
    {
      "label": "Alfa Slab One",
      "value": "'Alfa Slab One', sans-serif"
    },
    {
      "label": "Shadows Into Light",
      "value": "'Shadows Into Light', cursive"
    }
  ],
  "effects": [
    {
      "label": "Be efekto",
      "value": "none"
    },
    {
      "label": "Lengvas šešėlis",
      "value": "shadow"
    },
    {
      "label": "Baltas konturas",
      "value": "outline-white"
    },
    {
      "label": "Juodas konturas",
      "value": "outline-black"
    },
    {
      "label": "Švelnus švytėjimas",
      "value": "glow"
    },
    {
      "label": "Neoninė žydra",
      "value": "neon-cyan"
    },
    {
      "label": "Neoninė rožinė",
      "value": "neon-pink"
    },
    {
      "label": "Neoninė žalia",
      "value": "neon-green"
    },
    {
      "label": "Neoninė auksinė",
      "value": "neon-gold"
    }
  ],
  "presets": [
    {
      "label": "Y2K Pop",
      "sample": "POP",
      "font": "'Bungee', Impact, sans-serif",
      "color": "#ff477e",
      "effect": "outline-white",
      "bold": true,
      "italic": false,
      "underline": false,
      "align": "center"
    },
    {
      "label": "Chrome Club",
      "sample": "CLUB",
      "font": "'Bebas Neue', Impact, sans-serif",
      "color": "#111111",
      "effect": "outline-white",
      "bold": true,
      "italic": false,
      "underline": false,
      "align": "center"
    },
    {
      "label": "Neoninė rožinė",
      "sample": "NEON",
      "font": "'Monoton', Impact, sans-serif",
      "color": "#ff4fd8",
      "effect": "neon-pink",
      "bold": true,
      "italic": false,
      "underline": false,
      "align": "center"
    },
    {
      "label": "Kibernetinė žydra",
      "sample": "CYBER",
      "font": "'Orbitron', Arial, sans-serif",
      "color": "#00d8ff",
      "effect": "neon-cyan",
      "bold": true,
      "italic": false,
      "underline": false,
      "align": "center"
    },
    {
      "label": "Švelnus raštas",
      "sample": "cute",
      "font": "'Pacifico', cursive",
      "color": "#ff78b7",
      "effect": "glow",
      "bold": false,
      "italic": false,
      "underline": false,
      "align": "center"
    },
    {
      "label": "Princesė",
      "sample": "GLAM",
      "font": "'Playfair Display', Georgia, serif",
      "color": "#f4b942",
      "effect": "neon-gold",
      "bold": true,
      "italic": false,
      "underline": false,
      "align": "center"
    },
    {
      "label": "Minimalus",
      "sample": "clean",
      "font": "'Poppins', Arial, sans-serif",
      "color": "#111111",
      "effect": "none",
      "bold": true,
      "italic": false,
      "underline": false,
      "align": "center"
    },
    {
      "label": "Alternatyvus",
      "sample": "ALT",
      "font": "'Permanent Marker', 'Comic Sans MS', cursive",
      "color": "#ffffff",
      "effect": "outline-black",
      "bold": true,
      "italic": true,
      "underline": false,
      "align": "center"
    },
    {
      "label": "Mielas burbulas",
      "sample": "BUBBLE",
      "font": "'Rubik Bubbles', 'Arial Black', sans-serif",
      "color": "#7b61ff",
      "effect": "outline-white",
      "bold": true,
      "italic": false,
      "underline": false,
      "align": "center"
    },
    {
      "label": "Gatvės markeris",
      "sample": "TAG",
      "font": "'Permanent Marker', 'Comic Sans MS', cursive",
      "color": "#111111",
      "effect": "shadow",
      "bold": true,
      "italic": false,
      "underline": false,
      "align": "center"
    },
    {
      "label": "Pikselių žaidimas",
      "sample": "8BIT",
      "font": "'Press Start 2P', monospace",
      "color": "#08a66d",
      "effect": "outline-white",
      "bold": true,
      "italic": false,
      "underline": false,
      "align": "center"
    },
    {
      "label": "Prabangus serifas",
      "sample": "LUXE",
      "font": "'DM Serif Display', Georgia, serif",
      "color": "#111111",
      "effect": "none",
      "bold": true,
      "italic": false,
      "underline": false,
      "align": "center"
    }
  ]
};

/* Wall-art layer tools. Shares catalog content with the case studio, not its state. */
(() => {
  'use strict';
  const base = new URL('.', document.currentScript.src);
  const catalog = window.STRAYZY_WALL_CATALOG;
  const read = (key, fallback) => { try { return JSON.parse(localStorage.getItem(key)) ?? fallback; } catch { return fallback; } };
  const safeURL = value => typeof value === 'string' && (/^data:image\/(png|jpeg|webp|svg\+xml)[;,]/i.test(value) || (window.STICKER_CASE_Y2K_STICKERS||[]).some(item=>item.src===value));
  const clamp = (v,a,b) => Math.max(a,Math.min(b,Number(v)||0));
  const uid = () => crypto.randomUUID();
  const button = (label, action) => { const b=document.createElement('button'); b.type='button'; b.textContent=label; if(action)b.addEventListener('click',action); return b; };
  window.StrayzyWallEditor = class {
    constructor(root,state,draw,status) {
      this.root=root;this.state=state;this.draw=draw;this.status=status;this.cache=new Map();this.bounds=new Map();this.selected=null;
      this.fontFavorites=new Set(read('sz-font-favorites',[]));this.favorites=new Set(read('strayzy-wall-sticker-favorites',[]));
      this.mine=read('strayzy-wall-stickers',[]);if(!Array.isArray(this.mine))this.mine=[];this.mine=this.mine.filter(s=>s&&safeURL(s.src));
      this.library=(window.STICKER_CASE_Y2K_STICKERS||[]).map(s=>({...s,src:new URL(s.src,new URL('../',base)).href}));
      this.view='browse';this.pageSize=60;
      const customFonts=read('sz-custom-fonts',[]);if(Array.isArray(customFonts))for(const f of customFonts){if(!/^szfont_[a-f0-9]+$/.test(f?.family)||!/^data:.*;base64,/.test(f.data))continue;if(!catalog.fonts.some(v=>v.value===f.family))catalog.fonts.push({label:String(f.name||'Mano šriftas'),value:f.family});const face=new FontFace(f.family,`url(${f.data})`);face.load().then(font=>{document.fonts.add(font);this.draw();}).catch(()=>{});}
      this.items=(state.layerItems||[]).slice(0,100).map(v=>this.validate(v)).filter(Boolean);state.layerItems=this.items;
      if(!this.items.length && state.text)this.items.push(this.makeText(state.text,{font:state.font,color:state.textColor,size:state.textSize,x:50,y:state.textY}));
      this.selected=this.items.at(-1)?.id;this.history=[];this.future=[];this.last=JSON.stringify(this.items);
      this.build();this.renderLibrary();this.renderFonts();this.sync();
      for(const item of this.items)if(item.type==='sticker')this.load(item.src);
      document.fonts.ready.then(()=>this.draw());
    }
    $(s){return this.root.querySelector(s);}
    save(key,value){try{localStorage.setItem(key,JSON.stringify(value));}catch{this.status('Nepakanka vietos naršyklėje. Atsisiųsk dizaino PNG.');}}
    makeText(text='',extra={}){return {id:uid(),type:'text',text,font:catalog.fonts[1].value,color:'#111111',size:7,x:50,y:50,rotation:0,opacity:100,visible:true,bold:false,italic:false,underline:false,strike:false,align:'center',letterSpacing:0,lineHeight:110,effect:'none',...extra};}
    validate(v){
      if(!v||!['text','sticker'].includes(v.type))return null;
      if(v.type==='sticker'&&!safeURL(v.src))return null;
      const item=v.type==='text'?this.makeText(String(v.text||'').slice(0,100)): {id:uid(),type:'sticker',src:v.src,name:String(v.name||'Lipdukas').slice(0,150)};
      for(const [k,a,b,f] of [['x',0,100,50],['y',0,100,50],['size',1,v.type==='sticker'?Infinity:100,25],['rotation',-180,180,0],['opacity',0,100,100],['letterSpacing',-10,50,0],['lineHeight',70,200,110]])item[k]=clamp(Number.isFinite(v[k])?v[k]:f,a,b);
      for(const k of ['bold','italic','underline','strike','flipX','flipY','locked'])item[k]=v[k]===true;
      item.visible=v.visible!==false;
      if(/^#[\da-f]{6}$/i.test(v.color))item.color=v.color;
      if(catalog.fonts.some(f=>f.value===v.font))item.font=v.font;
      if(catalog.effects.some(e=>e.value===v.effect))item.effect=v.effect;
      if(['left','center','right','justify'].includes(v.align))item.align=v.align;
      item.outline=v.outline==='white'?'white':'none';return item;
    }
    get current(){return this.items.find(i=>i.id===this.selected);}
    ensureText(){if(this.current?.type==='text')return this.current;const i=this.makeText();this.items.push(i);this.selected=i.id;return i;}
    change(key,value){const item=this.current;if(!item||item.locked)return;item[key]=value;this.commit();}
    commit(){if(this.current)this.root.dataset.backgroundSelected='false';const next=JSON.stringify(this.items);if(next!==this.last){this.history.push(this.last);if(this.history.length>60)this.history.shift();this.future=[];this.last=next;}this.state.layerItems=this.items;this.state.text=this.current?.type==='text'?this.current.text:'';this.sync();this.draw();}
    undo(redo=false){const from=redo?this.future:this.history,to=redo?this.history:this.future;if(!from.length)return;to.push(JSON.stringify(this.items));this.items=JSON.parse(from.pop());this.last=JSON.stringify(this.items);this.state.layerItems=this.items;this.selected=this.items.at(-1)?.id;this.state.text=this.current?.type==='text'?this.current.text:'';this.sync();this.draw();}
    async prepareExport(){try{this.status('Ruošiamas dizainas…');await Promise.all(this.items.filter(i=>i.visible!==false).map(i=>i.type==='sticker'?(this.cache.get(i.src)||new Image()).decode():document.fonts.load(`24px ${i.font}`)));this.draw();return true;}catch{this.status('Ne visi lipdukai įkelti. Palauk arba pašalink nepasiekiamą sluoksnį.');return false;}}
    editMode(on){if(!on)this.root.dataset.backgroundSelected='false';this.$('.swa-stage').dataset.editing=String(on);this.root.querySelectorAll('[data-edit-mode]').forEach(b=>b.setAttribute('aria-pressed',String((b.dataset.editMode==='edit')===on)));this.draw();}
    build(){
      const nav=this.$('.swa-rail'), b=button('');b.dataset.tab='stickers';b.setAttribute('aria-pressed','false');
      b.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 2 3 6.3 7 .9-5.1 4.9 1.3 7L12 17.8l-6.2 3.3 1.3-7L2 9.2l7-.9Z"/></svg>Lipdukai';nav.insertBefore(b,nav.querySelector('[data-tab="photo"]'));
      const pane=document.createElement('section');pane.dataset.pane='stickers';pane.hidden=true;
      pane.innerHTML='<h2>Lipdukai</h2><input type="search" data-sticker-search placeholder="Ieškoti lipdukų…" aria-label="Ieškoti lipdukų"><div class="we-tabs"><button type="button" data-library-view="browse">Visi lipdukai</button><button type="button" data-library-view="favorites">Mėgstami</button><button type="button" data-library-view="mine">Mano įkelti</button></div><label>Kategorijos<select data-sticker-category><option value="">Visos kategorijos</option></select></label><button type="button" data-sticker-upload-button>Įkelti PNG</button><input type="file" data-sticker-upload accept="image/png,image/webp,image/jpeg,image/svg+xml" multiple hidden><p class="swa-hint" data-sticker-count></p><div class="we-sticker-grid"></div><button type="button" data-more-stickers>Rodyti daugiau</button><button type="button" data-clear-stickers>Išvalyti įkeltus lipdukus</button>';
      this.$('.swa-panel').append(pane);const background=button('Fonas');background.dataset.tab='background';background.className='we-mobile-background';this.$('[data-pane="templates"]').prepend(background);
      const categories=[...new Set(this.library.flatMap(s=>(s.groups?.length?s.groups:[s]).map(g=>g.category)).filter(Boolean))].sort();
      categories.forEach(c=>this.$('[data-sticker-category]').add(new Option(c,c)));
      for(const sel of ['[data-sticker-search]','[data-sticker-category]'])this.$(sel).addEventListener('input',()=>{this.pageSize=60;this.renderLibrary();});
      pane.querySelectorAll('[data-library-view]').forEach(b=>b.addEventListener('click',()=>{this.view=b.dataset.libraryView;this.pageSize=60;this.renderLibrary();}));
      this.$('[data-more-stickers]').addEventListener('click',()=>{this.pageSize+=60;this.renderLibrary();});
      this.$('[data-sticker-upload-button]').addEventListener('click',()=>this.$('[data-sticker-upload]').click());
      this.$('[data-sticker-upload]').addEventListener('change',e=>this.upload(e));
      this.$('[data-clear-stickers]').addEventListener('click',()=>{this.mine=[];this.save('strayzy-wall-stickers',[]);this.renderLibrary();});
      this.$('[data-pane="text"]').innerHTML=`<div class="we-heading"><h2>Tekstas</h2><button type="button" data-add-text>T₊ Pridėti tekstą</button></div><textarea data-text maxlength="100" rows="3" placeholder="Tavo tekstas…" aria-label="Tavo tekstas, iki 100 simbolių"></textarea><output data-text-count>0/100</output><div class="we-quick"></div><div class="we-swatches"></div><div class="we-tabs"><button type="button" data-text-section="fonts">Šriftai</button><button type="button" data-text-section="style">Stilius</button><button type="button" data-text-section="color">Spalva</button><button type="button" data-text-section="align">Lygiavimas</button></div><div data-text-area="fonts"><input type="search" data-font-search placeholder="Ieškoti šriftų…" aria-label="Ieškoti šriftų"><label class="we-checkbox"><input type="checkbox" data-font-favorites> Tik mėgstami</label><div class="we-font-list"></div></div><div data-text-area="style" hidden><h3>Teksto stilius</h3><div class="we-format">${[['bold','B','Paryškintas'],['italic','I','Kursyvas'],['underline','U','Pabrauktas'],['strike','S','Perbrauktas']].map(([k,l,t])=>`<button type="button" data-format="${k}"><b>${l}</b><small>${t}</small></button>`).join('')}</div><label>Teksto dydis<input type="range" data-text-property="size" min="1" max="30" step=".5"></label><label>Raidžių tarpai<input type="range" data-text-property="letterSpacing" min="-10" max="50"></label><label>Eilučių tarpai<input type="range" data-text-property="lineHeight" min="70" max="200"></label><details><summary>Teksto efektai ir ruošiniai</summary><div class="we-effects"></div><div class="we-presets"></div></details></div><div data-text-area="color" hidden><h3>Teksto spalva</h3><input type="color" data-text-color aria-label="Teksto spalva"><input type="text" data-hex maxlength="7" aria-label="HEX spalva"><button type="button" data-eyedropper>Paimti spalvą iš ekrano</button><div class="we-recent-colors"></div></div><div data-text-area="align" hidden><h3>Lygiavimas</h3><div class="we-pair">${[['left','Kairėje'],['center','Centre'],['right','Dešinėje'],['justify','Lygiuoti']].map(([v,l])=>`<button type="button" data-align="${v}">${l}</button>`).join('')}</div></div>`;
      this.$('[data-add-text]').addEventListener('click',()=>{const item=this.makeText(this.$('[data-text]').value||'Tavo tekstas');this.items.push(item);this.selected=item.id;this.editMode(true);this.commit();});
      this.$('[data-text]').addEventListener('input',e=>{const i=this.ensureText();if(i.locked)return;i.text=e.target.value;this.commit();});
      const quick=[['STRAYZY','Permanent Marker'],['Good Vibes','Great Vibes'],['Est. 2024','Oswald'],['Custom','Caveat'],['Y2K','Rubik Glitch']];
      quick.forEach(([t,f])=>{const font=catalog.fonts.find(v=>v.label===f);const b=button(t,()=>{const i=this.ensureText();if(i.locked)return;i.text=t;i.font=font.value;this.loadFont(i.font);this.commit();});b.style.fontFamily=font.value;this.$('.we-quick').append(b);});
      ['#111111','#ffffff','#c0c0d0','#ff1493','#ff9ed2','#b76e79','#b026ff','#c5a3ff','#00e5ff','#0a45ff','#ff6600','#ffcc00'].forEach(c=>{const b=button('',()=>{this.ensureText();this.change('color',c);});b.style.background=c;b.setAttribute('aria-label',c);this.$('.we-swatches').append(b);});
      this.root.querySelectorAll('[data-text-section]').forEach(b=>b.addEventListener('click',()=>{this.root.querySelectorAll('[data-text-area]').forEach(p=>p.hidden=p.dataset.textArea!==b.dataset.textSection);this.root.querySelectorAll('[data-text-section]').forEach(t=>t.setAttribute('aria-pressed',String(t===b)));}));
      this.$('[data-font-search]').addEventListener('input',()=>this.renderFonts());this.$('[data-font-favorites]').addEventListener('change',()=>this.renderFonts());
      this.root.querySelectorAll('[data-format]').forEach(b=>b.addEventListener('click',()=>{const i=this.ensureText();this.change(b.dataset.format,!i[b.dataset.format]);}));
      this.root.querySelectorAll('[data-text-property]').forEach(i=>i.addEventListener('input',()=>{this.ensureText();this.change(i.dataset.textProperty,Number(i.value));}));
      this.root.querySelectorAll('[data-align]').forEach(b=>b.addEventListener('click',()=>{this.ensureText();this.change('align',b.dataset.align);}));
      this.$('[data-text-color]').addEventListener('input',e=>{this.ensureText();this.change('color',e.target.value);});
      this.$('[data-hex]').addEventListener('change',e=>{if(/^#[\da-f]{6}$/i.test(e.target.value)){this.ensureText();this.change('color',e.target.value);}else this.sync();});
      this.$('[data-eyedropper]').hidden=!window.EyeDropper;this.$('[data-eyedropper]').addEventListener('click',async()=>{try{const r=await new EyeDropper().open();this.ensureText();this.change('color',r.sRGBHex);}catch{}});
      const colorMap=document.createElement('div');colorMap.className='we-color-map';colorMap.innerHTML='<div class="we-saturation" tabindex="0" role="slider" aria-label="Spalvos sodrumas ir šviesumas"><i></i></div><input type="range" data-hue min="0" max="359" value="225" aria-label="Atspalvis">';this.$('[data-text-area="color"]').prepend(colorMap);
      const saturation=colorMap.querySelector('.we-saturation');let hue=225,sat=1,val=1;
      const applyColor=()=>{const h=hue/60,c=val*sat,x=c*(1-Math.abs(h%2-1)),m=val-c;const rgb=h<1?[c,x,0]:h<2?[x,c,0]:h<3?[0,c,x]:h<4?[0,x,c]:h<5?[x,0,c]:[c,0,x];const hex='#'+rgb.map(v=>Math.round((v+m)*255).toString(16).padStart(2,'0')).join('');saturation.style.backgroundColor=`hsl(${hue} 100% 50%)`;saturation.querySelector('i').style.cssText=`left:${sat*100}%;top:${(1-val)*100}%`;saturation.setAttribute('aria-valuetext',hex);this.ensureText();this.change('color',hex);};
      const colorPoint=e=>{const r=saturation.getBoundingClientRect();sat=clamp((e.clientX-r.left)/r.width,0,1);val=1-clamp((e.clientY-r.top)/r.height,0,1);applyColor();};
      saturation.addEventListener('pointerdown',e=>{saturation.setPointerCapture(e.pointerId);colorPoint(e);});saturation.addEventListener('pointermove',e=>{if(saturation.hasPointerCapture(e.pointerId))colorPoint(e);});
      saturation.addEventListener('keydown',e=>{if(!['ArrowLeft','ArrowRight','ArrowUp','ArrowDown'].includes(e.key))return;e.preventDefault();sat=clamp(sat+(e.key==='ArrowRight'?.02:e.key==='ArrowLeft'?-.02:0),0,1);val=clamp(val+(e.key==='ArrowUp'?.02:e.key==='ArrowDown'?-.02:0),0,1);applyColor();});
      this.$('[data-hue]').addEventListener('input',e=>{hue=Number(e.target.value);applyColor();});
      const remember=()=>{const c=this.current?.color;if(!c)return;const colors=[c,...read('strayzy-wall-recent-colors',[]).filter(v=>v!==c)].slice(0,6);this.save('strayzy-wall-recent-colors',colors);renderRecent();};
      const renderRecent=()=>{const row=this.$('.we-recent-colors');row.replaceChildren();read('strayzy-wall-recent-colors',[]).filter(c=>/^#[\da-f]{6}$/i.test(c)).forEach(c=>{const b=button('',()=>{this.ensureText();this.change('color',c);});b.style.background=c;b.setAttribute('aria-label',c);row.append(b);});};
      saturation.addEventListener('pointerup',remember);this.$('[data-hue]').addEventListener('change',remember);this.$('[data-text-color]').addEventListener('change',remember);renderRecent();
      catalog.effects.forEach(e=>this.$('.we-effects').append(button(e.label,()=>{this.ensureText();this.change('effect',e.value);})));catalog.presets.forEach(p=>this.$('.we-presets').append(button(p.label,()=>{const i=this.ensureText();if(i.locked)return;Object.assign(i,{text:p.sample,font:p.font,color:p.color,effect:p.effect,bold:p.bold,italic:p.italic,underline:p.underline,align:p.align});this.loadFont(i.font);this.commit();})));
      const inspector=document.createElement('section');inspector.className='we-inspector';inspector.innerHTML='<h3>Redaguoti</h3><select data-layer-select aria-label="Pasirinktas sluoksnis"></select><div class="we-layer-controls"><label>Dydis<input data-layer-property="size" type="range" min="1" max="100" step=".5"><input data-layer-property="size" type="number" min="1" step=".5" aria-label="Elemento dydis, procentais"></label><label>Sukimas<input data-layer-property="rotation" type="range" min="-180" max="180"></label><label>Permatomumas<input data-layer-property="opacity" type="range" min="0" max="100"></label><div class="we-pair"><label>Vieta X, %<input type="number" data-layer-property="x" min="0" max="100"></label><label>Vieta Y, %<input type="number" data-layer-property="y" min="0" max="100"></label></div><div class="we-pair"><button type="button" data-layer-action="flipX">Apversti horizontaliai</button><button type="button" data-layer-action="flipY">Apversti vertikaliai</button><button type="button" data-layer-action="up">Į priekį</button><button type="button" data-layer-action="down">Atgal</button><button type="button" data-layer-action="duplicate">Dubliuoti</button><button type="button" data-layer-action="delete">Pašalinti</button><button type="button" data-layer-action="visible">Rodyti / slėpti</button><button type="button" data-layer-action="locked">Užrakinti</button></div><label>Lipduko apvadas<select data-outline><option value="none">Be apvado</option><option value="white">Su baltu apvadu</option></select></label></div>';
      this.inspector=inspector;
      const mobileLayers=document.createElement('details');mobileLayers.className='we-mobile-layers';mobileLayers.innerHTML='<summary>Sluoksniai</summary>';this.$('.swa-panel').append(mobileLayers);const layerList=this.$('[data-layers]');
      const layout=matchMedia('(max-width:1100px)');const placeInspector=()=>{(layout.matches?mobileLayers:this.$('.swa-layers')).append(layerList);(layout.matches?this.$('.swa-panel'):this.$('.swa-layers')).append(inspector);};layout.addEventListener('change',placeInspector);placeInspector();
      this.$('[data-layer-select]').addEventListener('change',e=>{this.selected=e.target.value;this.commit();});
      this.root.querySelectorAll('[data-layer-property]').forEach(i=>i.addEventListener('input',()=>{if(i.value===''||!Number.isFinite(Number(i.value)))return;const limit=i.dataset.layerProperty==='size'?(this.current?.type==='sticker'?Infinity:100):Number(i.max);this.change(i.dataset.layerProperty,clamp(i.value,Number(i.min),limit));}));
      this.$('[data-outline]').addEventListener('change',e=>this.change('outline',e.target.value));
      this.root.querySelectorAll('[data-layer-action]').forEach(b=>b.addEventListener('click',()=>this.action(b.dataset.layerAction)));
      const modes=document.createElement('div');modes.className='we-mode';modes.innerHTML='<button type="button" data-undo aria-label="Anuliuoti elemento pakeitimą">↶</button><button type="button" data-redo aria-label="Grąžinti elemento pakeitimą">↷</button><button type="button" data-edit-mode="edit">Redaguoti</button><button type="button" data-edit-mode="preview" aria-pressed="true">Peržiūra</button>';
      this.$('.swa-stage').prepend(modes);modes.querySelectorAll('[data-edit-mode]').forEach(b=>b.addEventListener('click',()=>this.editMode(b.dataset.editMode==='edit')));this.$('[data-undo]').addEventListener('click',()=>this.undo());this.$('[data-redo]').addEventListener('click',()=>this.undo(true));
      this.root.addEventListener('click',e=>{const b=e.target.closest('[data-tab]');if(!b)return;const edit=['text','stickers'].includes(b.dataset.tab);this.root.dataset.backgroundSelected='false';this.inspector.hidden=!edit;this.root.querySelectorAll('.swa-panel > .swa-section').forEach(s=>s.hidden=edit);this.editMode(edit);});
      const selection=document.createElement('div');selection.className='we-selection';selection.hidden=true;selection.innerHTML='<button type="button" data-handle="size" aria-label="Keisti dydį">↘</button><button type="button" data-handle="rotation" aria-label="Sukti">↻</button>';this.$('.swa-art').append(selection);this.selection=selection;
      this.root.addEventListener('click',e=>{if(e.target.closest('button[data-product]'))this.editMode(false);});
      this.bindDrag();
    }
    renderLibrary(){
      const query=this.$('[data-sticker-search]').value.toLowerCase(),cat=this.$('[data-sticker-category]').value;
      const entries=(this.view==='mine'?this.mine:[...this.library,...this.mine]).filter(s=>(this.view!=='favorites'||this.favorites.has(s.id))&&(!cat||(s.groups?.length?s.groups:[s]).some(g=>g.category===cat))&&(!query||[s.name,s.category,s.description,...(s.tags||[])].join(' ').toLowerCase().includes(query)));
      const grid=this.$('.we-sticker-grid');grid.replaceChildren();
      entries.slice(0,this.pageSize).forEach(s=>{const tile=document.createElement('div');tile.className='we-sticker-tile';const add=button('',()=>this.addSticker(s));add.setAttribute('aria-label',`Pridėti: ${s.name}`);add.dataset.addSticker=s.id;const img=document.createElement('img');img.src=s.src;img.alt=s.name;img.loading='lazy';add.append(img);const fav=button(this.favorites.has(s.id)?'★':'☆',()=>{this.favorites.has(s.id)?this.favorites.delete(s.id):this.favorites.add(s.id);this.save('strayzy-wall-sticker-favorites',[...this.favorites]);this.renderLibrary();});fav.className='we-favorite';fav.setAttribute('aria-label',`${s.name}: mėgstamas`);tile.append(add,fav);grid.append(tile);});
      this.$('[data-sticker-count]').textContent=entries.length?`${entries.length} lipdukai`:'Lipdukų nerasta.';this.$('[data-more-stickers]').hidden=entries.length<=this.pageSize;this.root.querySelectorAll('[data-library-view]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.libraryView===this.view)));
    }
    async load(src){if(this.cache.has(src))return this.cache.get(src);const image=new Image();image.crossOrigin='anonymous';this.cache.set(src,image);try{image.src=src;await image.decode();this.draw();}catch{this.cache.delete(src);this.status('Nepavyko įkelti lipduko.');}return image;}
    async addSticker(s){if(this.items.length>=100){this.status('Galima pridėti iki 100 sluoksnių.');return;}const img=await this.load(s.src);if(!img.naturalWidth)return;const item={id:uid(),type:'sticker',src:s.src,name:s.name,x:50,y:50,size:25,rotation:0,opacity:100,visible:true};this.items.push(item);this.selected=item.id;this.editMode(true);this.commit();}
    async upload(event){const files=[...event.target.files];event.target.value='';for(const file of files){if(!['image/png','image/jpeg','image/webp','image/svg+xml'].includes(file.type)||file.size>10*1024*1024){this.status('Rinkis PNG, JPG, WebP ar SVG iki 10 MB.');continue;}try{const src=await new Promise((resolve,reject)=>{const r=new FileReader();r.onload=()=>resolve(r.result);r.onerror=reject;r.readAsDataURL(file);});const img=await this.load(src);if(!img.naturalWidth)continue;this.mine.push({id:uid(),name:file.name,src,category:'Mano įkelti'});}catch{this.status('Nepavyko perskaityti lipduko.');}}this.save('strayzy-wall-stickers',this.mine);this.view='mine';this.renderLibrary();}
    renderFonts(){const list=this.$('.we-font-list'),query=this.$('[data-font-search]').value.toLowerCase(),only=this.$('[data-font-favorites]').checked;list.replaceChildren();const preferred=['Archivo Black','Bebas Neue','Oswald','Montserrat','Poppins','Caveat','Permanent Marker','Anton','Inter','Playfair Display','DM Sans','Raleway'];const fonts=[...catalog.fonts].sort((a,b)=>(preferred.indexOf(a.label)<0?100:preferred.indexOf(a.label))-(preferred.indexOf(b.label)<0?100:preferred.indexOf(b.label)));
      fonts.filter(f=>f.label.toLowerCase().includes(query)&&(!only||this.fontFavorites.has(f.value))).forEach(f=>{const row=document.createElement('div');row.className='we-font-row';const choose=button(`Aa   ${f.label}`,()=>{this.ensureText();this.change('font',f.value);this.loadFont(f.value);});const sample=document.createElement('b');sample.textContent='Aa';const name=document.createElement('span');name.textContent=f.label;choose.replaceChildren(sample,name);choose.style.fontFamily=f.value;choose.dataset.fontChoice=f.value;choose.setAttribute('aria-pressed',String(this.current?.font===f.value));const fav=button(this.fontFavorites.has(f.value)?'★':'☆',()=>{this.fontFavorites.has(f.value)?this.fontFavorites.delete(f.value):this.fontFavorites.add(f.value);this.save('sz-font-favorites',[...this.fontFavorites]);this.renderFonts();});fav.setAttribute('aria-pressed',String(this.fontFavorites.has(f.value)));fav.setAttribute('aria-label',`${f.label}: mėgstamas šriftas`);row.append(choose,fav);list.append(row);});if(!list.children.length)list.textContent='Šriftų nerasta.';
    }
    loadFont(font){document.fonts.load(`24px ${font}`).then(()=>this.draw()).catch(()=>this.status('Šriftas nepasiekiamas; naudojamas atsarginis šriftas.'));}
    action(action){const i=this.current;if(!i)return;if(action==='locked'){i.locked=!i.locked;this.commit();return;}if(i.locked)return;const index=this.items.indexOf(i);if(action==='delete'){this.items.splice(index,1);this.selected=this.items.at(-1)?.id;}else if(action==='duplicate'){const copy={...i,id:uid(),x:Math.min(95,i.x+4),y:Math.min(95,i.y+4)};this.items.push(copy);this.selected=copy.id;}else if(action==='up'||action==='down'){const to=clamp(index+(action==='up'?1:-1),0,this.items.length-1);this.items.splice(index,1);this.items.splice(to,0,i);}else if(['flipX','flipY'].includes(action))i[action]=!i[action];else if(action==='visible')i.visible=i.visible===false;this.commit();}
    sync(){const item=this.current;const text=item?.type==='text'?item:null;
      this.root.dataset.selectedType=item?.type||'';
      this.$('[data-undo]').disabled=!this.history.length;this.$('[data-redo]').disabled=!this.future.length;
      const select=this.$('[data-layer-select]');select.replaceChildren();if(!this.items.length)select.add(new Option('Pasirink lipduką arba pridėk tekstą',''));this.items.forEach(i=>select.add(new Option(i.type==='text'?(i.text||'Tekstas'):i.name,i.id)));select.value=item?.id||'';
      this.root.querySelectorAll('.we-layer-controls input,.we-layer-controls button,.we-layer-controls select').forEach(n=>n.disabled=!item||(item.locked&&n.dataset.layerAction!=='locked'));
      this.root.querySelectorAll('[data-layer-property="size"]').forEach(n=>{if(n.type==='range')n.max=item?.type==='sticker'?Math.max(100,Math.ceil((item.size||25)*2)):100;else if(item?.type==='sticker')n.removeAttribute('max');else n.max=100;});
      this.root.querySelectorAll('[data-layer-property]').forEach(n=>{if(document.activeElement!==n)n.value=item?.[n.dataset.layerProperty]??0;});
      this.$('[data-outline]').value=item?.outline||'none';this.$('[data-outline]').closest('label').hidden=item?.type!=='sticker';
      if(document.activeElement!==this.$('[data-text]'))this.$('[data-text]').value=text?.text||'';
      this.$('[data-text-count]').textContent=`${(text?.text||'').length}/100`;this.$('[data-text]').disabled=!!text?.locked;
      this.$('[data-text-color]').value=text?.color||'#111111';this.$('[data-hex]').value=text?.color||'#111111';
      this.root.querySelectorAll('[data-text-property]').forEach(n=>n.value=text?.[n.dataset.textProperty]??(n.dataset.textProperty==='lineHeight'?110:7));
      this.root.querySelectorAll('[data-format]').forEach(n=>n.setAttribute('aria-pressed',String(!!text?.[n.dataset.format])));this.root.querySelectorAll('[data-align]').forEach(n=>n.setAttribute('aria-pressed',String(text?.align===n.dataset.align)));
      this.root.querySelectorAll('[data-font-choice]').forEach(n=>n.setAttribute('aria-pressed',String(n.dataset.fontChoice===text?.font)));
    }
    drawLayers(ctx,canvas){this.bounds.clear();for(const i of this.items){if(i.visible===false)continue;ctx.save();ctx.translate(canvas.width*i.x/100,canvas.height*i.y/100);ctx.rotate(i.rotation*Math.PI/180);ctx.scale(i.flipX?-1:1,i.flipY?-1:1);ctx.globalAlpha=i.opacity/100;
      let w=0,h=0;
      if(i.type==='sticker'){const img=this.cache.get(i.src);if(img?.naturalWidth){w=canvas.width*i.size/100;h=w*img.naturalHeight/img.naturalWidth;if(i.outline==='white'){ctx.shadowColor='#fff';ctx.shadowBlur=0;for(const [x,y] of [[-4,0],[4,0],[0,-4],[0,4],[-3,-3],[3,3],[-3,3],[3,-3]]){ctx.shadowOffsetX=x;ctx.shadowOffsetY=y;ctx.drawImage(img,-w/2,-h/2,w,h);}ctx.shadowOffsetX=ctx.shadowOffsetY=0;}ctx.drawImage(img,-w/2,-h/2,w,h);}}
      else {const size=canvas.width*i.size/100;ctx.font=`${i.italic?'italic ':''}${i.bold?'800':'500'} ${size}px ${i.font}`;ctx.textBaseline='middle';ctx.fillStyle=i.color;ctx.letterSpacing=`${size*i.letterSpacing/100}px`;
        const lines=[];for(const paragraph of i.text.split('\n')){let line='';for(const word of paragraph.split(/\s+/)){const next=line?`${line} ${word}`:word;if(line&&ctx.measureText(next).width>canvas.width*.8){lines.push(line);line=word;}else line=next;}lines.push(line);}const step=size*i.lineHeight/100;w=Math.max(size,...lines.map(l=>ctx.measureText(l).width));h=lines.length*step;
        if(i.effect==='shadow'){ctx.shadowColor='#00000070';ctx.shadowBlur=size*.08;ctx.shadowOffsetX=size*.045;ctx.shadowOffsetY=size*.07;}
        if(i.effect==='glow'||i.effect.startsWith('neon')){const colors={'neon-cyan':'#00e5ff','neon-pink':'#ff1493','neon-green':'#39ff14','neon-gold':'#ffc928'};ctx.shadowColor=colors[i.effect]||i.color;ctx.shadowBlur=size*.2;}
        lines.forEach((line,n)=>{ctx.save();const width=ctx.measureText(line).width;const x=i.align==='left'?-w/2:i.align==='right'?w/2-width:-width/2;const y=(n-(lines.length-1)/2)*step;if(i.effect.startsWith('outline')){ctx.strokeStyle=i.effect==='outline-white'?'white':'black';ctx.lineWidth=size*.07;ctx.lineJoin='round';ctx.strokeText(line,x,y);}if(i.align==='justify'&&n<lines.length-1&&line.includes(' ')){const words=line.split(' '),gap=(w-words.reduce((a,t)=>a+ctx.measureText(t).width,0))/(words.length-1);let at=-w/2;words.forEach(word=>{ctx.fillText(word,at,y);at+=ctx.measureText(word).width+gap;});}else ctx.fillText(line,x,y);ctx.shadowBlur=0;ctx.shadowOffsetX=ctx.shadowOffsetY=0;if(i.underline||i.strike){ctx.strokeStyle=i.color;ctx.lineWidth=Math.max(1,size*.035);for(const offset of [i.underline?size*.45:null,i.strike?0:null])if(offset!==null){ctx.beginPath();ctx.moveTo(x,y+offset);ctx.lineTo(x+width,y+offset);ctx.stroke();}}ctx.restore();});
      }
      ctx.restore();this.bounds.set(i.id,{w:w/canvas.width*100,h:h/canvas.height*100});
    }}
    renderLayers(container){
      container.replaceChildren();
      const makeRow=(name,src,detail,selected,select)=>{
        const row=document.createElement('div');row.className='we-layer-row';row.classList.toggle('is-selected',selected);
        const main=button('',select);main.className='we-layer-main';main.setAttribute('aria-pressed',String(selected));
        const thumb=document.createElement('span');thumb.className='we-layer-thumb';
        if(src){const img=document.createElement('img');img.src=src;img.alt='';thumb.append(img);}else thumb.textContent='T';
        const text=document.createElement('span'),title=document.createElement('strong'),meta=document.createElement('small');title.textContent=name;meta.textContent=detail;text.append(title,meta);main.append(thumb,text);row.append(main);container.append(row);return row;
      };
      [...this.items].reverse().forEach(i=>{
        const index=this.items.indexOf(i),row=makeRow(i.type==='text'?(i.text||'Tekstas'):i.name,i.type==='sticker'?i.src:null,`${Math.round(i.size)}% / ${Math.round(i.rotation)}°${i.visible===false?' / Paslėptas':''}${i.locked?' / Užrakintas':''}`,i.id===this.selected,()=>{this.root.dataset.backgroundSelected='false';this.selected=i.id;this.editMode(true);this.commit();});
        const actions=document.createElement('div');actions.className='we-layer-actions';
        for(const [action,label,icon] of [['visible',i.visible===false?'Rodyti':'Slėpti','◉'],['locked',i.locked?'Atrakinti':'Užrakinti',i.locked?'▣':'□'],['up','Perkelti aukščiau','↑'],['down','Perkelti žemiau','↓'],['delete','Trinti','×']]){
          const b=button(icon,()=>{this.selected=i.id;this.action(action);});b.dataset.rowAction=action;b.title=label;b.setAttribute('aria-label',label);
          if(action==='locked')b.innerHTML=`<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="10" width="14" height="10" rx="2"/><path d="${i.locked?'M8 10V7a4 4 0 0 1 8 0v3':'M8 10V7a4 4 0 0 1 7.5-1.9'}"/></svg>`;
          if(action==='visible')b.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12Z"/><circle cx="12" cy="12" r="3"/></svg>';
          b.disabled=(i.locked&&action!=='locked')||(action==='up'&&index===this.items.length-1)||(action==='down'&&index===0);
          actions.append(b);
        }row.append(actions);
      });
      if(this.state.image){const row=makeRow('Fono paveikslėlis',this.state.image,'Automatiškai pritaikytas / Užrakintas',false,()=>{});row.querySelector('button').disabled=true;}
      const bg=makeRow('Fonas',null,'Visada apačioje',false,()=>{});bg.querySelector('.we-layer-thumb').textContent='';bg.querySelector('.we-layer-thumb').style.background=this.state.background;bg.querySelector('button').disabled=true;
      this.updateSelection();
    }
    updateSelection(){const i=this.current,b=i&&this.bounds.get(i.id);this.selection.hidden=!b||i.visible===false||this.$('.swa-stage').dataset.editing!=='true';if(!b)return;this.selection.style.cssText=`left:${i.x}%;top:${i.y}%;width:${b.w}%;height:${b.h}%;transform:translate(-50%,-50%) rotate(${i.rotation}deg)`;this.selection.classList.toggle('is-locked',!!i.locked);}
    clearStickerSelection(){if(this.current?.type!=='sticker')return;this.selected=null;this.sync();this.draw();}
    bindDrag(){const art=this.$('.swa-art');let drag=null;const point=e=>{const r=art.getBoundingClientRect();return {x:(e.clientX-r.left)/r.width*100,y:(e.clientY-r.top)/r.height*100,px:e.clientX,py:e.clientY};};
      document.addEventListener('pointerdown',e=>{if(!this.root.isConnected||art.contains(e.target)||e.target.closest('.we-layer-row,.we-inspector'))return;this.clearStickerSelection();});
      art.addEventListener('pointerdown',e=>{if(this.$('.swa-stage').dataset.editing!=='true')return;const p=point(e),handle=e.target.closest('[data-handle]')?.dataset.handle;let item=handle?this.current:null;if(!item&&this.root.dataset.backgroundSelected!=='true'){item=[...this.items].reverse().find(i=>{const b=this.bounds.get(i.id);if(!b||i.visible===false)return false;const angle=-i.rotation*Math.PI/180,dx=(p.x-i.x)*art.clientWidth/100,dy=(p.y-i.y)*art.clientHeight/100;return Math.abs(dx*Math.cos(angle)-dy*Math.sin(angle))<=b.w*art.clientWidth/200&&Math.abs(dx*Math.sin(angle)+dy*Math.cos(angle))<=b.h*art.clientHeight/200;});}if(!item){this.clearStickerSelection();return;}this.root.dataset.backgroundSelected='false';e.preventDefault();document.activeElement?.blur();this.selected=item.id;this.sync();this.draw();if(item.locked)return;const r=art.getBoundingClientRect(),cx=r.left+item.x*r.width/100,cy=r.top+item.y*r.height/100;drag={item,p,x:item.x,y:item.y,size:item.size,rotation:item.rotation,mode:handle||'move',cx,cy,distance:Math.hypot(p.px-cx,p.py-cy),angle:Math.atan2(p.py-cy,p.px-cx)};art.setPointerCapture(e.pointerId);});
      art.addEventListener('pointermove',e=>{if(!drag)return;const p=point(e),d=drag,i=d.item;if(d.mode==='move'){i.x=clamp(d.x+p.x-d.p.x,0,100);i.y=clamp(d.y+p.y-d.p.y,0,100);}if(d.mode==='size')i.size=clamp(d.size*Math.hypot(p.px-d.cx,p.py-d.cy)/Math.max(1,d.distance),1,i.type==='sticker'?Infinity:100);if(d.mode==='rotation')i.rotation=((d.rotation+(Math.atan2(p.py-d.cy,p.px-d.cx)-d.angle)*180/Math.PI+540)%360)-180;this.commit();});
      for(const type of ['pointerup','pointercancel','lostpointercapture'])art.addEventListener(type,()=>drag=null);
    }
  };
})();

/* STRAYZY Wall Art Studio 1.1.0 — standalone, no phone editor dependencies. */
(() => {
  'use strict';
  const base = new URL('.', document.currentScript.src);
  const isY2K = value => /y2k/i.test(value || '');
  const galleryPriority = item => isY2K(item.category) ? 0 : isY2K(`${item.name} ${item.id}`) ? 1 : 2;
  const galleryCatalog = (window.STICKER_CASE_BACKGROUND_PATTERNS || []).map(item => ({...item,src:new URL(item.src,new URL('../',base)).href,thumb:new URL(item.thumb||item.src,new URL('../',base)).href})).sort((a,b) => galleryPriority(a) - galleryPriority(b));
  document.querySelectorAll('[data-strayzy-wall-art]').forEach(mount);
  function mount(root) {
    if (root.dataset.wallArtReady) return;
    root.dataset.wallArtReady = 'true';
    root.classList.add('swa');
    root.innerHTML = `
      <nav class="swa-rail" aria-label="Redaktoriaus įrankiai">
        
        <button type="button" data-tab="templates" aria-pressed="true"><svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>Šablonai</button>
        <button type="button" data-tab="photo" aria-pressed="false"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5 9.5 3h5L16 5h4a2 2 0 0 1 2 2v12H2V7a2 2 0 0 1 2-2Z"/><circle cx="12" cy="12" r="4"/></svg>Foto</button>
        <button type="button" data-tab="text" aria-pressed="false"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 6V3h16v3M12 3v18M8 21h8"/></svg>Tekstas</button>
        <button type="button" data-tab="background" aria-pressed="false"><svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="1"/><path d="m3 13 10-10M3 20 17 6m-7 15L21 10m-4 11 4-4"/></svg>Fonas</button>
        <button type="button" data-tab="export" aria-pressed="false"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 12h18m-6-6 6 6-6 6"/></svg>Baigti</button><small>STRAYZY<br>ART STUDIO</small>
      </nav>
      <header class="swa-header"><div class="swa-announcement"><span>SUKURK KĄ NORS SAVO</span><span>YOUR ART. YOUR RULES. ✦</span></div><div class="swa-header-main"><a class="swa-logo" href="https://strayzy.com/" aria-label="STRAYZY pradžia"><img src="${window.StrayzyAsset('./assets/strayzy-logo.png')}" alt="STRAYZY"></a><nav class="swa-store-nav" aria-label="Parduotuvė"><a href="https://strayzy.com/collections/all">Parduotuvė</a><span aria-current="page">Drobės ir plakatai</span><a href="https://strayzy.com/pages/about-us">Apie mus</a><a href="https://strayzy.com/pages/contact">Kontaktai</a></nav><button type="button" class="swa-primary swa-finish" data-tab="export">Baigti dizainą →</button><span class="swa-mobile-title">Drobės ir plakatai</span></div></header>
      <aside class="swa-panel" aria-label="Dizaino nustatymai">
        <section class="swa-section"><h2>PRODUKTAS</h2><div class="swa-pair"><button type="button" class="swa-product" data-product="canvas"><i></i><b>Drobė</b><small>Spauda ant drobės</small></button><button type="button" class="swa-product" data-product="poster"><i></i><b>Plakatas</b><small>Spauda ant popieriaus</small></button></div></section>
        <section class="swa-section"><h2>Dydis</h2><select aria-label="Gaminio dydis" data-size><option value="30x40">30 × 40 cm · 3:4</option><option value="40x60">40 × 60 cm · 2:3</option><option value="50x70">50 × 70 cm · 5:7</option><option value="60x90">60 × 90 cm · 2:3</option></select><p class="swa-hint">Peržiūra prisitaiko prie pasirinkto dydžio.</p></section>
        <section data-pane="templates"><h2>Šablonai</h2><p class="swa-hint">Paspausk paveikslėlį – jis iškart atsiras ant gaminio.</p><div class="swa-gallery"></div></section>
        <section data-pane="photo" hidden><h2>Foto</h2><button type="button" data-action="upload">＋ Įkelti nuotrauką</button><input type="file" accept="image/jpeg,image/png,image/webp" data-upload hidden><p class="swa-hint">JPG, PNG arba WebP, iki 20 MB.</p><label>Vaizdo pritaikymas<select data-fit><option value="cover">Užpildyti visą gaminį</option><option value="contain">Rodyti visą paveikslėlį</option></select></label><p class="swa-hint">Užpildant kraštai gali būti apkirpti centre.</p><button type="button" data-action="clear-image">Pašalinti paveikslėlį</button></section>
        <section data-pane="text" hidden><h2>Tekstas</h2><label>Tekstas<input type="text" data-text maxlength="120" placeholder="Tavo tekstas…"></label><label>Šriftas<select data-font><option value="serif">Klasikinis</option><option value="sans-serif">Modernus</option><option value="cursive">Rankraštis</option></select></label><label>Teksto dydis<input type="range" data-text-size min="3" max="15" value="7"></label><label>Vertikali vieta<input type="range" data-text-y min="10" max="90" value="50"></label><label>Teksto spalva<input type="color" data-text-color value="#202a25"></label></section>
        <section data-pane="background" hidden><h2>Fonas</h2><div class="swa-colors"><input aria-label="Fono spalva" type="color" data-background value="#f5eee3"><span>Pasirink savo atspalvį</span></div><p class="swa-hint">Fonas matomas po paveikslėliu ir neužpildytuose kraštuose.</p></section>
        <section data-pane="export" hidden><h2>Baigti dizainą</h2><p class="swa-hint">Išsaugok dizainą arba atsisiųsk peržiūrą.</p><div class="swa-export-actions"><button type="button" data-action="save">Išsaugoti dizainą</button><button type="button" class="swa-primary" data-action="export">Atsisiųsti PNG</button></div><p class="swa-hint">PNG skirtas peržiūrai, ne gamybai.</p></section>
      </aside>
      <main class="swa-stage"><div class="swa-space"><canvas class="swa-poster-preview" role="img" aria-label="Plakato maketas"></canvas><div class="swa-art"><div class="swa-canvas-edge" aria-hidden="true"><canvas></canvas></div><canvas data-artwork aria-label="Tavo kūrinio peržiūra" role="img"></canvas></div></div><div class="swa-dimensions"></div><div class="swa-view-switch"><button type="button" data-product="canvas">Drobė</button><button type="button" data-product="poster">Plakatas</button></div><div class="swa-status" role="status" aria-live="polite"></div></main>
      <aside class="swa-layers"><h2>SLUOKSNIAI</h2><div data-layers></div></aside>`;
    const $ = selector => root.querySelector(selector);
    const state = { version:1, product:'canvas', size:'30x40', orientation:'portrait', image:null, imageName:'', fit:'cover', imageScale:100, imageX:0, imageY:0, background:'#f5eee3', text:'', font:'serif', textSize:7, textY:50, textColor:'#202a25' };
    let decoded = null, request = 0, restored = false, editor = null;
    const canvas = $('[data-artwork]'), ctx = canvas.getContext('2d');
    const edge = $('.swa-canvas-edge canvas'), edgeCtx = edge.getContext('2d');
    const posterPhoto=new Image(), preview=$('.swa-poster-preview');
    preview.width=1500;preview.height=1125;
    posterPhoto.onload=()=>{if(state.product==='poster' && $('.swa-stage').dataset.editing!=='true')drawPosterMockup();};
    posterPhoto.onerror=()=>status('Nepavyko įkelti maketo. Atnaujink puslapį.');
    posterPhoto.crossOrigin='anonymous';posterPhoto.src=new URL('sz-wall-poster-v1.png',base).href;
    function drawPosterMockup(){
      if(!posterPhoto.complete||!posterPhoto.naturalWidth)return;
      const out=preview.getContext('2d');out.setTransform(1.5,0,0,1.5,0,0);out.drawImage(posterPhoto,0,0,1000,750);
      const texture=document.createElement('canvas');texture.width=canvas.width;texture.height=canvas.height;
      const paint=texture.getContext('2d');paint.drawImage(canvas,0,0);
      const light=paint.createLinearGradient(0,0,0,texture.height);
      light.addColorStop(0,'#ffffff18');light.addColorStop(.45,'#00000006');light.addColorStop(.72,'#0000001c');light.addColorStop(1,'#ffffff0c');
      paint.fillStyle=light;paint.fillRect(0,0,texture.width,texture.height);
      const bez=(a,b,c,d,t)=>(1-t)**3*a+3*(1-t)**2*t*b+3*(1-t)*t*t*c+t**3*d;
      const edgePoint=(right,t)=>right?[bez(745,674,620,477,t),bez(232,406,524,634,t)]:[bez(436,362,319,159,t),bez(122,284,369,486,t)];
      // Overlapping narrow strips avoid antialiased mesh seams and keep print opaque.
      const W=texture.width,H=texture.height,steps=180;
      for(let i=0;i<steps;i++){
        const t=i/steps,u=(i+1)/steps,y=t*H,dy=H/steps;
        const l=edgePoint(false,t),r=edgePoint(true,t),L=edgePoint(false,u);
        // Small preview-only bleed covers the yellow source artwork and its
        // antialiased boundary, especially along the curved left paper edge.
        l[0]-=3.5;r[0]+=2;L[0]-=3.5;
        l[1]-=1;r[1]-=1;L[1]-=1;
        const a=(r[0]-l[0])/W,b=(r[1]-l[1])/W,c=(L[0]-l[0])/dy,d=(L[1]-l[1])/dy;
        out.save();out.transform(a,b,c,d,l[0]-c*y,l[1]-d*y);
        const band=Math.min(H-y,dy+6);
        out.drawImage(texture,0,y,W,band,0,y,W,band);out.restore();
      }
    }

    function dimensions() { return state.size.split('x').map(Number); }
    function status(message) { $('.swa-status').textContent = message; }
    function fitPreview() {
      const [w,h] = dimensions(), space = $('.swa-space');
      const room = state.product === 'canvas' || $('.swa-stage').dataset.editing === 'true';
      const art = $('.swa-art');
      if (!room) {
        const preview=$('.swa-poster-preview');
        const ratio=(4/3)*(w/h)/(2/3);
        const height=Math.min(space.clientHeight,space.clientWidth/ratio);
        preview.style.width=`${height*ratio}px`;preview.style.height=`${height}px`;
      } else {
        art.style.removeProperty('left'); art.style.removeProperty('top');
        const editing=$('.swa-stage').dataset.editing==='true';
        const scale = Math.max(.1, Math.min(space.clientWidth*(editing?.80:.68)/w,(space.clientHeight*(editing?.88:.76)-35)/h,8));
        art.style.width = `${w*scale}px`;
        art.style.setProperty('--swa-depth', `${w*scale*.10}px`);
        art.style.setProperty('--swa-perspective', `${w*scale*4}px`);
        art.style.height = `${h*scale}px`;
      }
    }
    function draw() {
      const [w,h] = dimensions();
      canvas.width = Math.round(1800*w/Math.max(w,h)); canvas.height = Math.round(1800*h/Math.max(w,h));
      ctx.fillStyle = state.background; ctx.fillRect(0,0,canvas.width,canvas.height);
      if (decoded) {
        const scale = Math[state.fit === 'cover' ? 'max' : 'min'](canvas.width/decoded.naturalWidth,canvas.height/decoded.naturalHeight);
        const iw=decoded.naturalWidth*scale, ih=decoded.naturalHeight*scale;
        ctx.drawImage(decoded,(canvas.width-iw)/2,(canvas.height-ih)/2,iw,ih);
      }
      editor?.drawLayers(ctx,canvas);
      // Separate mockup face: the preview edge never enters the exported artwork.
      edge.width=48; edge.height=canvas.height;
      edgeCtx.drawImage(canvas,canvas.width-Math.max(1,canvas.width*.025),0,Math.max(1,canvas.width*.025),canvas.height,0,0,48,edge.height);
      $('.swa-art').dataset.product=state.product;
      $('.swa-stage').dataset.product=state.product;
      root.querySelectorAll('button[data-product]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.product===state.product)));
      $('.swa-dimensions').textContent=`${state.product==='canvas'?'Drobė':'Plakatas'} / ${w} × ${h} cm`;
      const layers=$('[data-layers]'); layers.replaceChildren();
      for (const [icon,name] of [['▧',state.imageName],['◐','Fonas']]) {
        if (!name) continue;
        const row=document.createElement('div'); row.className='swa-layer';
        const mark=document.createElement('b'); mark.textContent=icon;
        const label=document.createElement('span'); label.textContent=name;
        row.append(mark,label); layers.append(row);
      }
      fitPreview();
      editor?.renderLayers(layers);
      root.dataset.imageReady=String(!!decoded && !!state.image);
      root.dispatchEvent(new Event('wall-art-change'));
      if(state.product==='poster' && $('.swa-stage').dataset.editing!=='true')drawPosterMockup();
    }
    async function setImage(src,name) {
      const token=++request; root.dataset.imageReady='false'; root.dispatchEvent(new Event('wall-art-change')); status('Įkeliamas paveikslėlis…');
      const img=new Image();img.crossOrigin='anonymous';
      try { img.src=src; await img.decode(); if(token!==request)return;
        // The shared, bundled gallery includes 139 MP print originals.
        // Keep the upload limit, but do not reject our own catalog artwork.
        if(!galleryCatalog.some(item=>item.src===src) && img.naturalWidth*img.naturalHeight>60000000) {
          status('Paveikslėlis per didelis. Įkelk failą iki 60 megapikselių.');
          return;
        }
        decoded=img; state.image=src; state.imageName=name; draw(); status('Paveikslėlis uždėtas ant gaminio.');
      } catch { if(token===request)status('Nepavyko įkelti paveikslėlio. Pabandyk dar kartą arba pasirink kitą failą.'); }
    }
    const gallery=$('.swa-gallery');
    const filters=document.createElement('div');filters.className='ws-gallery-filters';
    filters.innerHTML='<input type="search" data-gallery-search placeholder="Ieškoti paveikslėlių…" aria-label="Ieškoti paveikslėlių"><label>Kategorija<select data-gallery-category><option value="">Visos kategorijos</option></select></label><p class="swa-hint" data-gallery-count aria-live="polite"></p>';
    gallery.before(filters);
    [...new Set(galleryCatalog.map(i=>i.category).filter(Boolean))].sort((a,b)=>Number(isY2K(b))-Number(isY2K(a)) || a.localeCompare(b)).forEach(category=>$('[data-gallery-category]').add(new Option(category,category)));
    const more=document.createElement('button');more.type='button';more.dataset.galleryMore='';more.textContent='Rodyti daugiau';gallery.after(more);
    const galleryHome=document.createElement('span');galleryHome.hidden=true;filters.before(galleryHome);
    const openGallery=document.createElement('button');openGallery.type='button';openGallery.dataset.galleryOpen='';openGallery.className='swa-primary';openGallery.textContent='Rodyti visus paveikslėlius';galleryHome.before(openGallery);
    const galleryDialog=document.createElement('dialog');galleryDialog.className='swa-gallery-dialog';galleryDialog.setAttribute('aria-label','Paveikslėlių galerija');
    galleryDialog.innerHTML='<header><h2>Paveikslėlių galerija</h2><button type="button" data-gallery-close autofocus aria-label="Uždaryti galeriją">×</button></header><div class="swa-gallery-dialog-body"></div>';
    root.append(galleryDialog);
    const galleryBody=galleryDialog.querySelector('.swa-gallery-dialog-body');
    openGallery.addEventListener('click',()=>{galleryBody.append(filters,gallery,more);galleryDialog.showModal();if(!matchMedia('(max-width:1100px)').matches)$('[data-gallery-search]').focus({preventScroll:true});});
    galleryDialog.querySelector('[data-gallery-close]').addEventListener('click',()=>galleryDialog.close());
    galleryDialog.addEventListener('close',()=>{galleryHome.after(filters,gallery,more);openGallery.focus({preventScroll:true});});
    galleryDialog.addEventListener('keydown',event=>{if(event.key==='Escape')event.stopPropagation();});
    galleryDialog.addEventListener('click',event=>{if(event.target===galleryDialog){const r=galleryDialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)galleryDialog.close();}});
    let galleryLimit=48;
    function renderGallery(){
      const query=$('[data-gallery-search]').value.trim().toLocaleLowerCase(),category=$('[data-gallery-category]').value;
      const entries=galleryCatalog.filter(item=>(!category||item.category===category)&&(!query||`${item.name} ${item.category}`.toLocaleLowerCase().includes(query)));
      gallery.replaceChildren();
      entries.slice(0,galleryLimit).forEach(item=>{
        const button=document.createElement('button');button.type='button';button.dataset.galleryId=item.id;button.setAttribute('aria-label',`Pasirinkti: ${item.name}`);
        const image=document.createElement('img');image.src=item.thumb;image.alt=item.name;image.loading='lazy';image.decoding='async';
        const caption=document.createElement('small');caption.textContent=item.name;button.append(image,caption);
        button.addEventListener('click',()=>{setImage(item.src,item.name);if(galleryDialog.open)galleryDialog.close();});gallery.append(button);
      });
      $('[data-gallery-count]').textContent=entries.length?`Rodoma ${Math.min(galleryLimit,entries.length)} iš ${entries.length} paveikslėlių`:'Paveikslėlių nerasta.';
      more.hidden=entries.length<=galleryLimit;
    }
    for(const selector of ['[data-gallery-search]','[data-gallery-category]'])$(selector).addEventListener('input',()=>{galleryLimit=48;renderGallery();});
    more.addEventListener('click',()=>{galleryLimit+=48;renderGallery();});
    renderGallery();
    root.addEventListener('click',async event=>{
      const b=event.target.closest('button'); if(!b)return;
      if(b.dataset.tab) { root.querySelectorAll('[data-pane]').forEach(p=>p.hidden=p.dataset.pane!==b.dataset.tab); root.querySelectorAll('[data-tab]').forEach(t=>t.setAttribute('aria-pressed',String(t.dataset.tab===b.dataset.tab))); }
      if(b.dataset.product) {state.product=b.dataset.product; draw();}
      if(b.dataset.action==='upload') $('[data-upload]').click();
      if(b.dataset.action==='clear-image') {++request; decoded=null; state.image=null; state.imageName=''; draw(); status('Paveikslėlis pašalintas.');}
      if(b.dataset.action==='save') {try{localStorage.setItem('strayzy-wall-art-v1',JSON.stringify(state));status('Dizainas išsaugotas šioje naršyklėje.');}catch{status('Nepakanka naršyklės vietos. Atsisiųsk PNG peržiūrą.');}}
      if(b.dataset.action==='export') {
        if(editor && !await editor.prepareExport())return;
        canvas.toBlob(blob=>{ if(!blob){status('Nepavyko sukurti PNG.');return;} const url=URL.createObjectURL(blob), a=document.createElement('a'); a.href=url; a.download=`strayzy-${state.product}-${state.size}-preview.png`; a.click(); setTimeout(()=>URL.revokeObjectURL(url),1000); status('PNG peržiūra atsisiųsta.'); },'image/png');
      }
    });
    const bindings={'size':'size','fit':'fit','background':'background'};
    Object.entries(bindings).forEach(([attr,key])=>{ $(`[data-${attr}]`).addEventListener('input',e=>{state[key]=['textSize','textY'].includes(key)?Number(e.target.value):e.target.value;draw();}); });
    $('[data-upload]').addEventListener('change',async event=>{
      const file=event.target.files[0]; event.target.value=''; if(!file)return;
      if(!['image/jpeg','image/png','image/webp'].includes(file.type)||file.size>20*1024*1024){status('Pasirink JPG, PNG arba WebP failą iki 20 MB.');return;}
      const token=++request, reader=new FileReader(); reader.onload=()=>{if(token===request)setImage(reader.result,file.name);}; reader.onerror=()=>status('Nepavyko perskaityti failo.'); reader.readAsDataURL(file);
    });
    new ResizeObserver(fitPreview).observe($('.swa-space'));
    try {
      const saved=JSON.parse(localStorage.getItem('strayzy-wall-art-v1'));
      if(saved?.version===1) {
        restored = true;
        if(saved.size==='35x40')saved.size='30x40';
        if(Array.isArray(saved.layerItems))state.layerItems=saved.layerItems;
        const choices={product:['canvas','poster'],size:['30x40','40x60','50x70','60x90'],fit:['cover','contain'],font:['serif','sans-serif','cursive']};
        for(const [key,values] of Object.entries(choices))if(values.includes(saved[key]))state[key]=saved[key];
        for(const key of ['background','textColor'])if(/^#[0-9a-f]{6}$/i.test(saved[key]))state[key]=saved[key];
        if(typeof saved.text==='string')state.text=saved.text.slice(0,120);
        for(const [key,min,max] of [['textSize',3,15],['textY',10,90]])if(Number.isFinite(saved[key]))state[key]=Math.max(min,Math.min(max,saved[key]));
        if(typeof saved.image==='string' && (saved.image.startsWith('data:image/')||saved.image.startsWith(new URL('assets/',base).href)||galleryCatalog.some(item=>item.src===saved.image))) {state.image=saved.image;state.imageName=String(saved.imageName||'Paveikslėlis').slice(0,200);}
      }
    }catch { /* Storage may be disabled; editing still works. */ }
    Object.entries(bindings).forEach(([attr,key])=>$(`[data-${attr}]`).value=state[key]);
    editor = new window.StrayzyWallEditor(root,state,draw,status);
    // Checkout reads the existing artwork and design; rendering/export remain unchanged.
    root.prepareWallCart = async () => {
      if (state.image && root.dataset.imageReady !== 'true') throw new Error('Palauk, kol bus įkeltas paveikslėlis.');
      if (!await editor.prepareExport()) throw new Error('Dizainas dar neparuoštas. Patikrink įkeltus elementus.');
      const design = JSON.parse(JSON.stringify(state));
      const usedFonts = new Set((design.layerItems || []).filter(item => item.type === 'text').map(item => item.font));
      try { design.customFonts = JSON.parse(localStorage.getItem('sz-custom-fonts') || '[]').filter(font => usedFonts.has(font.family)); } catch { design.customFonts = []; }
      const preview = await new Promise((resolve, reject) => canvas.toBlob(blob => blob ? resolve(blob) : reject(new Error('Nepavyko paruošti dizaino peržiūros.')), 'image/png'));
      return {design, preview};
    };
    draw();
    if(state.image)setImage(state.image,state.imageName);
    // New designs begin with the guided background choice.
  }
})();


/* Presentation adapter: mirrors the case studio without touching artwork state. */
(() => {
  document.querySelectorAll('.swa').forEach(root => {
    const panel = root.querySelector('.swa-panel');
    const heading = document.createElement('div');
    heading.className = 'we-sheet-head';
    heading.innerHTML = '<span>Šablonai</span><button type="button" aria-label="Uždaryti skydelį">×</button>';
    panel.prepend(heading);
    root.dataset.sheet = 'open';
    const close = () => { root.querySelector('[data-edit-mode="preview"]').click(); root.dataset.sheet = 'closed'; window.dispatchEvent(new Event('resize')); };
    heading.querySelector('button').addEventListener('click', close);
    root.addEventListener('keydown', event => { if (event.key === 'Escape') close(); });
    root.addEventListener('click', event => {
      const tab = event.target.closest('[data-tab]');
      if (!tab) return;
      root.dataset.sheet = 'open';
      heading.querySelector('span').textContent = ({templates:'Šablonai',stickers:'Lipdukai',photo:'Foto',text:'Tekstas',background:'Fonas',export:'Baigti dizainą'})[tab.dataset.tab];
      root.querySelectorAll('.swa-panel > .swa-section').forEach(section => { section.hidden = tab.dataset.tab !== 'templates'; });
      panel.scrollTop = 0;
      window.dispatchEvent(new Event('resize'));
    });
    const textarea = root.querySelector('[data-text]');
    const entry = document.createElement('div'); entry.className = 'we-text-entry';
    textarea.before(entry); entry.append(textarea, root.querySelector('[data-text-count]'));
    root.querySelector('[data-text-section="fonts"]').setAttribute('aria-pressed', 'true');
    // Keep optional library maintenance behind the same disclosure as the case tool.
    const options = document.createElement('details'); options.className = 'we-library-options';
    options.innerHTML = '<summary>Bibliotekos parinktys</summary>';
    const clear = root.querySelector('[data-clear-stickers]'); clear.before(options); options.append(clear);
  });
})();

/* Guided setup uses the editor's existing controls and preserves all layers. */
(() => {
  document.querySelectorAll('.swa').forEach(root => {
    const q = s => root.querySelector(s), panel = q('.swa-panel');
    let step = 1, reached = 1, productChosen = true, background = null, navigating = false;
    const nav = document.createElement('nav'); nav.className = 'ws-steps'; nav.setAttribute('aria-label', 'Kūrimo žingsniai');
    nav.innerHTML = ['Gaminys', 'Fonas', 'Dizainas'].map((name,i) => `<button type="button" data-step="${i+1}"><b>${i+1}</b>${name}</button>`).join('');
    panel.insertBefore(nav, q('.we-sheet-head').nextSibling);
    const choices = document.createElement('section'); choices.className = 'ws-background';
    choices.innerHTML = '<h2>Pasirink foną</h2><div class="swa-pair"><button type="button" data-base="color">Fono spalva</button><button type="button" data-base="image">Paveikslėlis</button></div><div class="ws-image-source"><button type="button" data-tab="templates">Paveikslėlių galerija</button><button type="button" data-action="upload">Įkelti savo</button></div>';
    nav.after(choices);
    const colorInput = q('[data-background]');
    const palette = document.createElement('div'); palette.className = 'ws-palette';
    palette.setAttribute('role', 'group'); palette.setAttribute('aria-label', 'Rekomenduojamos fono spalvos');
    const colors = [
      ['Balta','#ffffff'],['Dramblio kaulo','#fffaf0'],['Kreminė','#f5eee3'],['Smėlio','#e7d5ba'],['Pilka','#b8b8b8'],['Juoda','#111111'],
      ['Švelni rožinė','#f8dce5'],['Pelenų rožinė','#d9a5b3'],['Rožinė','#f58bb7'],['Avietinė','#d54575'],['Vyšninė','#982c47'],['Bordo','#572b3a'],
      ['Persikinė','#ffd3b6'],['Abrikosinė','#f7b87c'],['Terakota','#c9795c'],['Oranžinė','#f08036'],['Raudona','#dc4141'],['Šokoladinė','#694b3e'],
      ['Vanilinė','#fff2b8'],['Geltona','#ffdd45'],['Ochra','#d9ae58'],['Šalavijų','#b7c7a5'],['Alyvuogių','#818b54'],['Miško žalia','#294d3c'],
      ['Mėtinė','#d3eee2'],['Pistacijų','#d6e4bc'],['Žalsvai mėlyna','#78b6b1'],['Turkio','#24b8b0'],['Petrolio','#286c75'],['Tamsi žalsva','#204447'],
      ['Žydra','#d5e8f5'],['Dangaus mėlyna','#99c5e8'],['Mėlyna','#467bcc'],['Elektrinė mėlyna','#0a45ff'],['Alyvinė','#d9c9ed'],['Tamsiai mėlyna','#253452']
    ];
    colors.forEach(([name,color]) => {
      const swatch = document.createElement('button'); swatch.type = 'button'; swatch.dataset.backgroundSwatch = color;
      swatch.style.backgroundColor = color; swatch.title = name;
      swatch.setAttribute('aria-label', name); swatch.setAttribute('aria-pressed', 'false');
      swatch.addEventListener('click', () => { colorInput.value = color; colorInput.dispatchEvent(new Event('input', {bubbles:true})); });
      palette.append(swatch);
    });
    const paletteTitle = document.createElement('h3'); paletteTitle.textContent = 'Rekomenduojamos spalvos';
    q('.swa-colors').before(paletteTitle, palette);
    q('.swa-colors span').textContent = 'Arba pasirink savo atspalvį';
    const footer = document.createElement('div'); footer.className = 'ws-footer';
    footer.innerHTML = '<p role="status" class="swa-hint" data-step-hint></p><div class="swa-pair"><button type="button" data-step-back>← Atgal</button><button type="button" class="swa-primary" data-step-next>Toliau →</button></div>';
    panel.append(footer);
    const showTab = name => { navigating = true; q(`.swa-rail [data-tab="${name}"]`).click(); navigating = false; };
    const backgroundReady = () => background === 'color' || (background === 'image' && root.dataset.imageReady === 'true');
    const ready = () => step === 1 ? productChosen : backgroundReady();
    function sync() {
      palette.querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.backgroundSwatch === colorInput.value.toLowerCase())));
      root.dataset.step = step;
      nav.querySelectorAll('button').forEach(b => { b.disabled = Number(b.dataset.step) > reached || (b.dataset.step === '3' && !backgroundReady()); b.setAttribute('aria-current', Number(b.dataset.step) === step ? 'step' : 'false'); });
      root.querySelectorAll('.swa-panel > .swa-section').forEach(n => n.hidden = step !== 1);
      if (step === 1) root.querySelectorAll('[data-pane]').forEach(n => n.hidden = true);
      choices.hidden = step !== 2;
      q('.ws-image-source').hidden = background !== 'image';
      choices.querySelectorAll('[data-base]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.base === background)));
      q('.we-inspector').hidden = step !== 3 || !['text','stickers'].some(tab => q(`.swa-rail [data-tab="${tab}"]`).getAttribute('aria-pressed') === 'true');
      footer.hidden = step === 3;
      q('[data-step-back]').disabled = step === 1;
      q('[data-step-next]').disabled = !ready();
      q('[data-step-hint]').textContent = step === 1 ? 'Pasirink drobę arba plakatą ir dydį.' : !background ? 'Pasirink fono spalvą arba paveikslėlį.' : background === 'image' && !ready() ? 'Pasirink paveikslėlį galerijoje arba įkelk savo.' : 'Fonas paruoštas. Toliau – lipdukai ir tekstas.';
      q('.we-sheet-head span').textContent = step === 1 ? 'Gaminys' : step === 2 ? 'Fonas' : 'Dizainas';
    }
    function go(value) {
      step = value; root.dataset.step = value; root.dataset.sheet = 'open';
      showTab(step === 3 ? 'stickers' : step === 2 ? (background === 'color' ? 'background' : 'templates') : 'templates');
      if (step === 2 && !background) root.querySelectorAll('[data-pane]').forEach(n => n.hidden = true);
      q('[data-edit-mode="preview"]').click();
      sync(); panel.scrollTop = 0;
    }
    root.addEventListener('click', event => {
      const tab = event.target.closest('[data-tab]');
      if (!tab || navigating) return;
      const allowed = step === 3 || (step === 2 && background === 'image' && ['templates','photo'].includes(tab.dataset.tab));
      if (!allowed) { event.preventDefault(); event.stopImmediatePropagation(); }
    }, true);
    root.addEventListener('click', event => {
      const b = event.target.closest('button'); if (!b) return;
      if (b.matches('[data-product]')) productChosen = true;
      if (b.dataset.base) {
        background = b.dataset.base;
        if (background === 'color') { q('[data-action="clear-image"]').click(); showTab('background'); }
        else showTab('templates');
      }
      if (b.hasAttribute('data-step-next') && ready()) { reached = Math.max(reached, step+1); go(step+1); }
      else if (b.hasAttribute('data-step-back')) go(Math.max(1,step-1));
      else if (b.dataset.step && Number(b.dataset.step) <= reached) go(Number(b.dataset.step));
      sync();
    });
    root.addEventListener('wall-art-change', sync);
    root.addEventListener('keydown', () => { if (step < 3) root.dataset.sheet = 'open'; });
    go(1);
    // The storefront collection CTA opens the existing gallery without resetting a draft.
    if (new URLSearchParams(window.location.search).get('gallery') === '1') {
      background = 'image';
      reached = 2;
      go(2);
      q('[data-gallery-open]').click();
    }
  });
})();

/* Mobile presentation only. Artwork and export coordinates stay in the editor. */
(() => {
  document.querySelectorAll('.swa').forEach(root => {
    const mobile = matchMedia('(max-width:1100px)');
    const panel = root.querySelector('.swa-panel');
    const head = root.querySelector('.we-sheet-head');
    const grip = document.createElement('button');
    grip.type = 'button';
    grip.className = 'we-sheet-grip';
    grip.setAttribute('aria-label', 'Išplėsti arba sumažinti panelę');
    grip.innerHTML = '<i></i>';
    head.append(grip);
    let drag = null, suppressClick = false, frame = 0, currentHeight = null;
    const limits = () => {
      const height = root.clientHeight;
      const nav = root.querySelector('.swa-rail').getBoundingClientRect().height;
      const max = Math.max(90, height - nav);
      return {max, compact: Math.min(max, Math.max(170, height * .38)), min: Math.min(90, max)};
    };
    function paint(height) {
      const l = limits();
      currentHeight = Math.max(l.min, Math.min(l.max, height));
      root.style.setProperty('--we-sheet-height', `${currentHeight}px`);
      grip.setAttribute('aria-expanded', String(currentHeight >= l.max - 1));
    }
    function size(value) {
      root.dataset.sheetSize = value;
      grip.setAttribute('aria-expanded', String(value === 'expanded'));
      const l = limits();
      paint(value === 'expanded' ? l.max : l.compact);
    }
    function cancelDrag() {
      cancelAnimationFrame(frame); frame = 0;
      drag = null;
      delete root.dataset.sheetDragging;
    }
    function viewport() {
      cancelDrag();
      if (mobile.matches) {
        root.style.setProperty('--we-viewport', `${window.visualViewport?.height || innerHeight}px`);
        root.style.setProperty('--we-viewport-top', `${window.visualViewport?.offsetTop || 0}px`);
        if (currentHeight === null) size('compact');
        else paint(currentHeight);
      }
    }
    grip.addEventListener('click', () => {
      if (suppressClick) { suppressClick = false; return; }
      size(currentHeight >= limits().max - 1 ? 'compact' : 'expanded');
    });
    grip.addEventListener('pointerdown', event => {
      if (!mobile.matches || event.button !== 0) return;
      suppressClick = false;
      drag = {id:event.pointerId, y:event.clientY, height:panel.getBoundingClientRect().height, moved:false, next:currentHeight};
      grip.setPointerCapture(event.pointerId);
    });
    grip.addEventListener('pointermove', event => {
      if (drag?.id !== event.pointerId) return;
      const delta = event.clientY - drag.y;
      if (!drag.moved && Math.abs(delta) < 6) return;
      drag.moved = true;
      root.dataset.sheetDragging = 'true';
      drag.next = drag.height - delta;
      if (!frame) frame = requestAnimationFrame(() => {
        frame = 0;
        if (drag) paint(drag.next);
      });
    });
    grip.addEventListener('pointerup', event => {
      if (drag?.id !== event.pointerId) return;
      const moved = drag.moved;
      const height = drag.height - (event.clientY - drag.y);
      cancelDrag();
      if (moved) {
        suppressClick = true;
        root.dataset.sheetSize = 'custom';
        paint(height);
      }
    });
    grip.addEventListener('pointercancel', () => { suppressClick = !!drag?.moved; cancelDrag(); });
    root.addEventListener('click', event => {
      if (event.target.closest('[data-tab],[data-step-next],[data-step-back],.ws-steps button')) {
        cancelDrag();
      }
    });
    root.addEventListener('focusin', event => {
      if (mobile.matches && event.target.matches('textarea,input:not([type="color"]):not([type="range"])')) {
        cancelDrag();
      }
    });
    window.visualViewport?.addEventListener('resize', viewport);
    window.visualViewport?.addEventListener('scroll', viewport);
    window.addEventListener('resize', viewport);
    mobile.addEventListener('change', viewport);
    viewport();
  });
})();

/* Shopify handoff for wall art only. Keep the original design and preview attached. */
(() => {
  const configNode = document.getElementById('strayzy-wall-cart-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  document.querySelectorAll('[data-strayzy-wall-art]').forEach(root => {
    const finish = root.querySelector('.swa-finish');
    const layers = root.querySelector('.swa-layers');
    const header = root.querySelector('.swa-header-main');
    finish.removeAttribute('data-tab');
    finish.dataset.wallAdd = '';
    finish.textContent = 'Įdėti į krepšelį';
    const message = document.createElement('p');
    message.className = 'swa-cart-message'; message.setAttribute('role', 'status');
    const cartLink = document.createElement('a'); cartLink.href = config.root + 'cart';
    cartLink.textContent = 'Peržiūrėti krepšelį'; cartLink.hidden = true;
    const controls = document.createElement('div'); controls.className = 'swa-cart-controls';
    controls.append(finish, message, cartLink);
    const media = matchMedia('(max-width:1100px)');
    const place = () => (media.matches ? header : layers).append(controls);
    media.addEventListener('change', place); place();
    root.querySelector('[data-pane="export"] h2').textContent = 'Dizaino kopija';
    let pending = false, added = false;
    finish.addEventListener('click', async () => {
      if (pending || added) return;
      if (root.dataset.step !== '3') { message.textContent = 'Pirmiausia pasirink gaminį ir foną.'; return; }
      pending = true; root.inert = true; finish.disabled = true;
      finish.textContent = 'Pridedama…'; message.textContent = ''; cartLink.hidden = true;
      let submitted = false;
      try {
        const {design, preview} = await root.prepareWallCart();
        const product = config.products[design.product];
        const variant = product?.variants?.find(v => v.option1 === design.size);
        if (!variant?.available) throw new Error('Šio gaminio ir dydžio šiuo metu negalima užsakyti.');
        const designId = crypto.randomUUID();
        design.handoff = {designId, product:design.product, size:design.size, variantId:variant.id, createdAt:new Date().toISOString(), previewOnly:true};
        const form = new FormData();
        form.append('id', String(variant.id)); form.append('quantity', '1');
        form.append('properties[Dizaino numeris]', designId);
        form.append('properties[_Dizaino duomenys]', new Blob([JSON.stringify(design)], {type:'application/json'}), designId + '.json');
        form.append('properties[_Dizaino peržiūra]', preview, designId + '-preview.png');
        submitted = true;
        const response = await fetch(config.root + 'cart/add.js', {method:'POST', body:form, headers:{Accept:'application/json'}});
        const result = await response.json();
        if (!response.ok) { submitted = false; throw new Error(result.description || 'Nepavyko pridėti į krepšelį.'); }
        added = true;
        if (['_Dizaino duomenys','_Dizaino peržiūra'].some(key => !/^(https:\/\/|\/\/|\/uploads\/)/.test(result.properties?.[key] || ''))) {
          throw new Error('Prekė pridėta, tačiau dizaino failai nepatvirtinti. Patikrink krepšelį prieš tęsiant.');
        }
        message.textContent = 'Pridėta į krepšelį.';
        location.assign(config.root + 'cart');
      } catch (error) {
        message.textContent = submitted && !added ? 'Nepavyko patvirtinti rezultato. Patikrink krepšelį prieš kartodamas.' : error.message;
        cartLink.hidden = !submitted && !added;
        // An uncertain POST must not silently create duplicate customized products.
        if (submitted) added = true;
      } finally {
        pending = false; root.inert = false; finish.disabled = added;
        finish.textContent = added ? 'Patikrink krepšelį' : 'Įdėti į krepšelį';
      }
    });
  });
})();
